import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { BaseGridTemplate } from '../../../../../shared/cgp-grid/base-cgp-grid.template';
import { Validators, FormBuilder } from '@angular/forms';
import { ProgramService, GlobalRegionService, ModelYearService, ProgramStyleService } from '../../../mesc.service';
import { Program } from '../../../../../shared/model';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { MaintenanceService } from "../maintenance.service";


@Component({
  selector: 'Programs',
  template: '<cgp-grid [template]="template" [editDataItem]="editDataItem" [formDialog]="formDialog" [editForm]="editForm" (setModel)="setModelHandler()"></cgp-grid>',
})
export class ProgramsComponent extends BaseGridTemplate {
  private readonly maintenanceService: MaintenanceService;

  constructor(
    private formBuilder: FormBuilder,
    private readonly injector: Injector,


    /** Declare services here
     * EXAMPLE:
     * private userService: UserService,
     * private moduleService: ModuleService
     * 
     */

    private ProgramService: ProgramService,
    private GlobalRegion: GlobalRegionService,
    private Model: ModelYearService,
    private Style: ProgramStyleService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
  ) {
    super();
    this.maintenanceService = injector.get(MaintenanceService);
    this.maintenanceService.getCurrentPageValue();
    /** Call services here (optional)
     * EXAMPLE:
     * this.moduleService.query() or functionService.getById('{path}{id}')
     * 
     */

  }

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;
  editForm = this.formBuilder.group({
    Id: [],
    CreatedBy: [],
    CreatedDate: [],

    /** Define form fields here
     * EXAMPLE:
     * FirstName: [{value: ''}, Validators.required],
     * LastName: [],
     * Email: [Validators.required],
     * ModuleId: [{ value: [] }, Validators.required],
     * 
     */

    ProgramCode: ["", Validators.required],
    ModelYearId: ["", Validators.required],
    GlobalRegionId: ["", Validators.required],
    ProgramDescription: ["", Validators.required],
    IsActive: [false, Validators.required],
    ProgramStyleId: ["", Validators.required],

  })

  /** Define columns here
   * EXAMPLE:
   * columns: [
   * {
   *     field: Firstname,
   *     title: First Name
   * },
   * {
   *     field: Email,
   *     title: Email,
   *     template: {
   *         type: 'email',
   *     },
   * },
   * {
   *     field: "ModuleId",
   *     title: "Module",
   *     template: {
   *         type: 'filter',
   *         pipe: 'moduleName',
   *         dataSource: this.moduleService,
   *     }
   * },
   * {
   *     field: "GMIN",
   *     title: "",
   *     width: 55,
   *     template: {
   *         type: 'person'
   *     }
   * },
   * ]
   */
  columns = [
    {
      field: 'ProgramCode',
      title: 'Program Code'
    },
    {
      field: 'ProgramDescription',
      title: 'Description'
    },
    {
      field: 'GlobalRegion',
      title: 'Global Region',
    },
    {
      field: 'ProgramStyle',
      title: 'Style',
    },
    {
      field: 'ProgramModelYear',
      title: 'Model Year',
    },
    {
      field: 'IsActive',
      title: 'Status',
      width: 125,
      template: {
        type: "boolean",
        onLabel: "Active",
        offLabel: "Inactive"
      }
    },
  ]

  onSave = (dataItem, isNew) => {
    var self = this;
    self.ProgramService.save(dataItem, isNew, "", true, false)
      .then(function () {
        self.grid.refresh(true);
        self.cgpSnackbarService.showSnackbar({
          message: isNew ? "Record has been created" : "Record has been updated",
          duration: 2000
        });
      }).catch(function (response) {
        self.ProgramService.loading.next(false);
        self.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      })
  }

  onRead = () => {
    var self = this;
    return self.ProgramService.read('', true);
  }

  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true,
    },
    columns: this.columns,
    save: this.onSave,
    read: this.onRead,
    service: this.ProgramService,
    fileName: 'programs.xlsx'
  }

  formDialog = {
    title: "Programs",
    formControls: [
      {
        type: "text",
        name: "ProgramCode",
        title: "Program Code*",
      }, {
        type: "text",
        name: "ProgramDescription",
        title: "Program Description*",
      },
      {
        type: "combobox",
        readonly: "update",
        name: "GlobalRegionId",
        title: "Global Region*",
        textField: 'Description',
        valueField: 'Id',
        placeholder: 'Select Region...',
        service: this.GlobalRegion,
      },
      {
        type: "combobox",
        name: "ModelYearId",
        title: "Model Year*",
        textField: 'Year',
        valueField: 'Id',
        placeholder: 'Select Model Year...',
        service: this.Model,

      },
      {
        type: "combobox",
        readonly: "update",
        name: "ProgramStyleId",
        title: "Program Style*",
        textField: 'ProgramStyleDescripton',
        valueField: 'Id',
        placeholder: 'Select Program Style...',
        service: this.Style,

      },
      {
        type: "boolean",
        name: "IsActive",
        title: "Active",
      }],
  }
  public ngOnInit(): void {
    this.GlobalRegion.query();
    this.Model.query();
    this.Style.query();
  }


  setModelHandler(): void {
    this.editDataItem = new Program();
    this.editDataItem.IsActive = true;
  }

}
